import { useAuth } from '../auth/AuthProvider';

export default function LogoutButton() {
  const { clearAuth } = useAuth();

  const handleLogout = async () => {
    await clearAuth();
  };

  return <button onClick={handleLogout}>Logout</button>;
}
